import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.some.js";
function f(s, p, u = !0, t = null) {
  return s.split(" ").every((r) => {
    const n = p.some((e) => u ? r === e || r === `${e}@xs` || r === `${e}@sm` || r === `${e}@md` || r === `${e}@lg` : r === e);
    return n || (t ? t(`Invalid prop value: ${r}`) : console.error(`Invalid prop value: ${r}`)), n;
  });
}
export {
  f as default
};
